import { Box, Chip, capitalize } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid";
import { CHIP_COLOR_OVERRIDES } from "../../utils/chip-colors";
import type { TestCase } from "./types";

const getStatusColor = (status: string) => {
  switch (status) {
    case "persisted":
    case "passed":
      return "success";
    case "ready":
    case "running":
      return "info";
    case "draft":
      return "default";
    case "discarded":
    case "failed":
    case "failed_pending":
      return "error";
    case "flaky":
      return "warning";
    default:
      return "default";
  }
};

export const StatusCell = (params: GridRenderCellParams<TestCase>) => {
  const statusColor = getStatusColor(params.value);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
      }}
    >
      <Chip
        label={capitalize(params.value.replace(/_/g, " "))}
        variant="outlined"
        size="small"
        color={
          statusColor as
            | "default"
            | "primary"
            | "secondary"
            | "error"
            | "info"
            | "success"
            | "warning"
        }
        sx={{
          fontSize: "0.75rem",
          fontWeight: 500,
          height: 24,
          "& .MuiChip-label": {
            px: 1.5,
          },
          borderWidth: 1.5,
          ...CHIP_COLOR_OVERRIDES,
        }}
      />
    </Box>
  );
};
